<template>
  <div>
    <!-- initial text -->
    <div v-if="initialText" class="menu-text initial-text" ref="initialTextContainer">
      <i class="sherpa-icon icon-bombilla"></i>
      <span v-html="initialText"></span>
    </div>

    <!-- definition -->
    <definition
      :type="type"
      :content="content"
      :id="id"
      :fromPopup="fromPopup"
      :saveDefinition="saveDefinition"
      :saveDefinitionTo="saveDefinitionTo"
      :language="language"
      :visuals="visuals"
      :authorization="authorization"
      :apiparams="apiparams"
      :showloading="true"
      :menuName="name"
      :taskObject="taskObject"
      :objectChanged="objectChanged"
      :callCreateFromNew="callCreateFromNew"
      :detailParentContentId="detailParentContentId"
      :apiDefinitionId="apiDefinitionId"
      @definitionloading="definitionLoading"
      @definitionloaded="definitionLoaded"
      @definitionerror="definitionError"
      @refreshDefinition="refreshDefinition"
      @formDataActionCalled="formDataActionCalled"
      @closeDetail="closeDetail"
      @changeUrl="changeUrl"
      @popupClose="popupClose"
      @validatingFormError="validatingFormError"
      @callAction="callAction"
      @waitingProcessInit="waitingProcessInit"
      @modifyingAddForm="modifyingAddForm"
      @taskLink="taskLink"
      @removeUrlQueryParam="removeUrlQueryParam"
      @refreshDefinitionTitle="refreshDefinitionTitle"
    />
    <span v-if="type.actions && type.actions.create" class="exit_new">
      <i class="fas fa-angle-left" @click="exitNew()"></i>
    </span>
  </div>
</template>

<script>
// import Definition from 'vue-definition' // component definition in vue-definition node module
import Definition from './definition' // component definition in this src directory
import languages from '@/language/languages'
import moment from 'moment'
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'
import { router } from '@/router'
import Configuration from '@/configuration'
import menu from '@/utils/menu'
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-loader',
  props: [
    'type',
    'content',
    'id',
    'fromPopup',
    'name',
    'saveDefinition',
    'saveDefinitionTo',
    'searcherDetailDefinition',
    'taskObject',
    'detailParentContentId',
    'apiDefinitionId',
    'initialText',
    'endText'
  ],
  data () {
    return {
      language: {},
      visuals: this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`],
      authorization: window.localStorage.getItem('user-token'),
      apiparams: {
        multimediaurl: Configuration.value('API_MULTIMEDIA_URL'),
        mapsKey: Configuration.value('API_GOOGLE_MAPS_KEY'),
        translateKey: Configuration.value('API_GOOGLE_TRANSLATE_KEY'),
        translateUrl: Configuration.value('API_GOOGLE_TRANSLATE_URL'),
        htmlAbsolutePath: Configuration.value('API_HTML_ABSOLUTE_PATH'),
        tinymcetmdRootPath: Configuration.value('API_TINYMCETMD_ROOT_PATH'),
        tinymcetmdSkinPath: Configuration.value('API_TINYMCETMD_SKIN_PATH'),
        tinymcetmdLangPath: Configuration.value('API_TINYMCETMD_LANG_PATH').replace('{{lang}}', this.$ml.current),
        assetsPath: '/',
        newAssetsManager: Configuration.value('APP_NEW_ASSETS_MANAGER')
      },
      requestObjectBackup: null,
      objectChanged: false,
      callCreateFromNew: null
    }
  },
  components: {
    Definition
  },
  beforeMount () {
    this.language = languages[this.$ml.current]
    this.type.domainEndpoint = Configuration.value('API_SERVICES_URL') + moment().valueOf()
    this.requestObjectBackup = JSON.stringify(this.content.requestObject)
  },
  methods: {
    taskLink (obj) {
      router.push(obj).catch(() => {})
    },
    removeUrlQueryParam () {
      this.$router.push(this.$route.path).catch(() => {})
    },
    definitionLoading () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
    },
    waitingProcessInit () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true)
    },
    modifyingAddForm () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
    },
    definitionLoaded (content) {
      this.$emit('definitionLoaded', content)
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
    },
    definitionError (error, resultError, container) {
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, error)
      this.$emit('definitionError', error, resultError, container)
    },
    refreshDefinition (newRequestObject) {
      let changed = (newRequestObject !== null && JSON.stringify(newRequestObject) !== this.requestObjectBackup)
      this.objectChanged = changed
      this.$emit('refreshDefinition', newRequestObject, changed)
    },
    refreshDefinitionTitle (definitionTitle) {
      this.$emit('refreshDefinitionTitle', definitionTitle)
    },
    callAction (type, loadingShow) {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, loadingShow)
    },
    formDataActionCalled (stay) {
      // Sin espera perceptible: el aviso ahora es un toast montado en document.body
      // que sobrevive a la navegación, así que "guardar y salir" va al buscador al
      // instante (antes había un setTimeout de 3.5s heredado de la capa bloqueante).
      // Diferimos la navegación UN tick para que el watcher de message.vue dispare
      // el toast antes de que el detalle se desmonte (si no, no llegaría a salir).
      var vm = this
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      this.$nextTick(function () {
        vm.$emit('formDataActionCalled', stay)
      })
    },
    closeDetail () {
      if (!this.searcherDetailDefinition) {
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
      }
    },
    changeUrl (goTo) {
      this.$router.push(goTo).catch(() => {})
    },
    popupClose () {
      this.$emit('popupClose')
    },
    validatingFormError () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      this.$emit('validatingFormError')
    },
    exitNew () {
      if (
        (!this.objectChanged && this.type.id !== 'template') || transport.methods.allDefinitionReadable(this.content.requestDefinition)
      ) {
        this.goParentMenu()
      } else {
        // Dialog
        let message = this.$ml.get('saveChangesAfterClose')
        let options = {
          okText: this.$ml.get('save'),
          cancelText: this.$ml.get('continueWithoutSaving'),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(message, options)
          .then((dialog) => {
            this.callCreateFromNew = moment().valueOf()
            // this.callCreate(false)
          })
          .catch(() => {
            this.goParentMenu()
          })
      }
    },
    goParentMenu () {
      var searcherMenu = menu.methods.getSearcherMenuOfNewOption(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], this.id)
      if (searcherMenu) {
        this.$router.push(searcherMenu.parentContextPath + searcherMenu.contextPath)
      }
    }
  },
  watch: {
    type (type) {
      type.domainEndpoint = Configuration.value('API_SERVICES_URL') + moment().valueOf()
    }
  }
}
</script>

<style lang="scss">
#sherpaCrmApp {
  .menu-text {
    display: flex;
    align-items: flex-start; /* para alinear el icono arriba si el texto es multilínea */
    gap: 6px; /* separación entre icono y texto */
    padding: 10px 12px 8px;
    border: 1px dotted #003640;
    background-color: #80acff76;
    font-family: 'Source Sans Pro';
    font-size: 14px;
    color: #444;
    margin-bottom: 10px;
    flex: 1;
    text-align: justify;
  }

  .menu-text i.icon-bombilla {
    font-size: 16px;
    color: #0d0040;
    flex-shrink: 0; /* que el icono no se deforme */
    margin: 0;
  }

  .definition-title {
    span.definition-title-id {
      display: none !important;
      color: #fff;
      font-size: 16px;
    }

    span:first-of-type {
      display: block;
    }
  }
  .definitionObj {
    padding: 0 15px 5px 3px;
    text-align: left;

    &.group {
      padding: 0 15px 0 3px;
      min-height: 0;

      .definition-wrapper.group {
        padding-top: 0 !important;

        &.repeatable-group {
          background-color: #f9f9f9 !important;
          border: 1px #a8f3fa solid;
          padding-bottom: 0;
          min-height: initial;

          .group-header {
            margin-bottom: 0;
            background-color: #a8f3fa !important;
          }
        }
      }
    }

    &.gallery {
      padding: 0;
    }

    .label {
      font-weight: 500;
      font-family: "Source Sans Pro", sans-serif;
      vertical-align: top;
      padding-top: 3px;
      padding-bottom: 2px;
    }

    &.conditional {
      padding: 0;
      min-height: 0;

      .group {
        padding: 0;
        margin: 0;
      }

      .definition-wrapper.group {
        padding: 0 !important;
        margin-bottom: 0 !important;

        .group-elements {
          padding: 0 !important;
        }
        .group-elements.add-repeatable-group-item {
          padding: 6px 10px !important;
        }
      }
    }

    &.placeholder {
      label.label {
        color: transparent;
      }
    }
  }

  .definition-wrapper {
    padding: 2px 0 0;
    min-height: 47px;

    &.text {
      .w3-input {
        font-size: 14px;
        font-family: 'Noto Sans';
        height: 33px;
      }
    }
    &.conditional {
      padding: 0;
      min-height: 0;
    }
  }
  .exit_new {
    bottom: 11px;
    top: auto;
    left: 122px;
    color: #ff7643;
    cursor: pointer;
    z-index: 20000000;
    position: fixed;
    width: 17px;

    i {
      font-size: 33px;
      transition: color 0.2s ease-in;

      &:hover {
        color: #d42e12;
      }
    }
  }
  #type_actions {
    position: fixed;
    bottom: 0;
    left: 100px;
    right: 0;
    height: 62px;
    background-color: #000;
    z-index: 1000000;

    .formErrors,
    .formSaved {
      font-family: "Source Sans Pro", sans-serif;;
      font-size: 19px;
      font-weight: 600;
    }

    button {
      margin-right: 18px;
      padding: 0 20px;
      height: 45px;
      border-radius: 0;
      background-color: #d42e12;
      float: right;
      transition: all .2s ease-in;

      span {
        font-family: "Source Sans Pro", sans-serif;
        font-weight: 600;
        font-size: 20px;
      }
    }

    .containerFormConfirmDelete {
      button {
        background-color: #fff;
      }

      .formConfirmDelete {
        display: none;
      }
    }
  }

  .noButtons {
    #type_actions {
      .messages {
        width: 100%;
      }
    }
  }

  .repeatable {
    .list-complete-item {
      position: relative;
      transition: all 0.4s ease-in;
      transform: none !important;
      padding: 0 0 15px !important;
      margin: 0 0 10px;
      overflow-x: hidden;
      overflow-y: auto;
      border: 1px solid #e0e0e0;

      &.modifying {
        z-index: 10000000000;
        width: initial;
        position: fixed;
        top: 50px;
        bottom: 50px;
        left: 150px;
        right: 50px;
        overflow-y: hidden;
        background-color: #f5f5f5;
        margin: 0;
        padding: 0 !important;

        .buttons.modify {
          top: initial;
        }

        > .groupTasks {
          display: none;
        }

        .slot {
          padding-bottom: 0;
          padding-left: 0;
          overflow-y: auto;
          position: absolute;
          right: 20px;
          left: 25px;
          bottom: 72px;
          top: 10px;

          &::-webkit-scrollbar {
            width: 12px;
          }

          &::-webkit-scrollbar-track {
            background: #f1f1f1;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 10px;
            border: 3px solid #f1f1f1;
          }

          &::-webkit-scrollbar-thumb:hover {
            background-color: #555;
          }&::-webkit-scrollbar {
            width: 12px;
          }

          &::-webkit-scrollbar-track {
            background: #f1f1f1;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 10px;
            border: 3px solid #f1f1f1;
          }

          &::-webkit-scrollbar-thumb:hover {
            background-color: #555;
          }
        }
      }
    }
    .repeatableGroupReadOnly {
      .tiny {
        max-height: 500px;
        overflow: hidden;
      }
      .label {
        padding-top: 6px;
      }
    }
  }
  .repeatableButtons {
    button {
      span {
        font-family: "Source Sans Pro", sans-serif;
      }
    }
  }
  .get-singlefile-company,
  .get-singlefile-professional,
  .get-singlefile-individual,
  .get-indicators-individual,
  .get-indicators-professional,
  .get-indicators-company {
    > #container_form_definition {
      padding: 0 0 0 0 !important;
      left: 500px;
      bottom: 70px;
      top: 100px;
      right: 18px;
      width: auto;
      position: fixed;
      overflow-y: hidden;

      .definition-title {
        display: none;
      }
    }
    .update-and-out {
      display: none;
    }
    #form_definition,
    #form_definition>form>.definitionObj.group,
    .definition-wrapper .group-elements {
      position: absolute;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      padding: 0;
    }
    .definitionObj.group {
      position: absolute;
      top: 10px;
      bottom: 10px;
      right: 10px;
      left: 10px;
      padding: 0;
    }
    .appsur_cuestionarios_questcreationdata {
      display: none;
    }
    .definition-wrapper.group {
      padding: 0 !important;
      margin: 0 0 1px 0 !important;
      background-color: #f0f0f0 !important;
    }
  }
  .get-cpg-form,
  .get-cpg-tlmkt,
  .get-cpg-postal,
  .get-consent-form {
    .repeatable {
      .list-complete-item {
        &.modifying {
          padding: 0 0 10px 380px !important;

          .slot {
            & > [data-simplebar] {
              left: 370px;
              right: 0;
              width: initial;
            }
          }
          .definition-builder {
            .questions_searcher .language {
              top: 169px;
            }
            .questions_searcher_fixed {
              left: 163px !important;
              bottom: 125px !important;
              top: 103px !important;
            }
          }
          &.list-complete-item .slot .inner-slot {
            position: fixed;
            bottom: 125px;
            top: 103px;
            right: 53px;
            left: 540px;
            width: initial;
            padding: 0;

            #appsur_cuestionarios_questcreationdata {
              position: absolute;
              left: 0;
              right: 13px;
              bottom: 0;
              top: 260px;
              padding: 0;

              .group-header {
                display: none;
              }

              .group-elements {
                padding: 0;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;

                #appsur_cuestionarios_questsection {
                  padding: 0;
                  position: absolute;
                  right: 15px;
                  left: 0;
                  bottom: 0;
                  top: 0;
                }
              }
            }
          }
        }
      }
    }

    .repeatableButtons {
      top: auto;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }

    #appsur_cuestionarios_questblockdata > .definition-wrapper.open {
      & > .group-elements {
        position: fixed;
        left: 495px;
        right: 17px;
        width: auto;
        float: none;
        bottom: 90px;
        top: 106px;
        overflow-y: auto;

        & > div:first-child {
          position: absolute;
          right: 0;
          left: 0;
          top: 25px;
          bottom: 0;
        }
      }
      & > .repeatable {
        display: none;
      }
      .definitionObj.group {
        padding: 0;

        > .definition-wrapper.group > .group-elements {
          padding: 0;
        }

        &#appsur_cuestionarios_questcreationdata {
          position: absolute;
          right: 0;
          left: 0;
          bottom: 0px;
          top: 280px;

          .group-header {
            display: none;
          }
          .group-elements,
          #appsur_cuestionarios_questsection {
            position: absolute;
            right: 15px;
            left: 0;
            bottom: 0;
            top: 0;
          }

          .definition-wrapper.group {
            margin: 0;
          }
        }

        [data-simplebar] {
          top: 0;
        }
      }
    }
  }

  .get-consent-form {
    #appsur_cuestionarios_questblockdata > .definition-wrapper.open {
      .definitionObj.group {
        &#appsur_cuestionarios_questcreationdata {
          top: 206px;
        }
      }
    }
  }

  .gjs-new-asset-manager {
    .gjs-searcher-input {
      background-color: #ccc;
      color: #666;
    }

    i {
      color: #999;
      background-color: rgba(255,255,255,0.6);
    }

    .gjs-am-assets-footer {
      text-align: center;
    }

    button {
      background-color: #ccc;
      color: #666;

      &.selected,
      &:hover {
        background-color: hsla(0,0%,100%,.5) !important;
      }
    }

    .total {
      color: #666;
      padding-top: 5px;
    }

    .loading {
      text-align: center;

      img {
        position: relative;
      }
    }
  }

}
</style>
